import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import type { Lang } from '../../data/translations';
const options: {
  code: Lang;
  flag: string;
  short: string;
  label: string;
}[] = [{
  code: 'en',
  flag: '🇺🇸',
  short: 'EN',
  label: 'English'
}, {
  code: 'es',
  flag: '🇲🇽',
  short: 'ES',
  label: 'Español'
}];
export function LanguageToggle({
  tone = 'light'
}: {
  tone?: 'light' | 'dark';
}) {
  const {
    lang,
    setLang,
    t
  } = useLanguage();
  const wrap = tone === 'light' ? 'border-petal bg-white' : 'border-white/20 bg-white/5';
  const idle = tone === 'light' ? 'text-ink/60 hover:bg-petal/60 hover:text-mauve-deep' : 'text-white/70 hover:bg-white/10 hover:text-white';
  return <div role="group" aria-label={t.common.nav.languageLabel} className={`flex items-center gap-0.5 rounded-full border p-1 ${wrap}`} data-id="element-211" data-mp="32b67dm3waik6">
      {options.map(option => {
      const active = option.code === lang;
      return <button key={option.code} type="button" onClick={() => setLang(option.code)} aria-pressed={active} lang={option.code} title={option.label} className={`flex h-8 items-center gap-1.5 rounded-full px-2.5 text-xs font-medium transition-colors duration-150 ease-smooth ${active ? 'bg-mauve text-white' : idle}`} data-id="element-212" data-mp="17x5dzgr46nrh">
            <span aria-hidden="true" className="text-sm leading-none" data-id="element-213" data-mp="2473uv5fq2cme">
              {option.flag}
            </span>
            {option.short}
          </button>;
    })}
    </div>;
}